"use client";

import clsx from "clsx";
import { Strategy } from "@/stores/strategiesStore";
import { formatReturn, formatCurrencyCompact } from "@/utils/format";
import { SHOW_STRATEGY_PERFORMANCE } from "@/utils/constants";

interface StrategyMetricsProps {
  strategy: Strategy;
}

export const StrategyMetrics = ({ strategy }: StrategyMetricsProps) => {
  // Issue #131: return/AUM figures are disputed pending an exporter fix +
  // restatement — hidden from the catalog UI until SHOW_STRATEGY_PERFORMANCE
  // flips back to true.
  if (!SHOW_STRATEGY_PERFORMANCE) {
    return (
      <p className="text-center text-xs text-slate-500">Performance data under review</p>
    );
  }

  const metrics = [
    { label: "Lifetime", value: strategy.lifetimeReturn },
    { label: "1 Year", value: strategy.yearReturn },
    { label: "30 Day", value: strategy.monthReturn },
    { label: "AUM", value: null, display: formatCurrencyCompact(strategy.totalAum) },
  ];

  return (
    <div className="grid grid-cols-4 gap-3">
      {metrics.map((metric) => (
        <div key={metric.label} className="text-center">
          <p className="text-xs text-slate-500">{metric.label}</p>
          {metric.value !== null ? (
            <p
              className={clsx(
                "text-sm font-semibold",
                metric.value >= 0 ? "text-emerald-400" : "text-rose-400"
              )}
            >
              {formatReturn(metric.value, 1)}
            </p>
          ) : (
            <p className="text-sm font-semibold text-white">{metric.display}</p>
          )}
        </div>
      ))}
    </div>
  );
};
